module.exports = __webpack_public_path__ + "static/media/logo.4c837f51.png";